export default __webpack_public_path__ + "static/media/grafema_clivitalbio_03.fbdf7537.jpg";